import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const RequestOTPAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LOGIN.METHOD](APIConfig.LOGIN.URL, payload);
}

const VerifyOTPAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_OTP.METHOD](APIConfig.VERIFY_OTP.URL, payload);
}

const CheckLoginAPICall = (token: string) => {
    // @ts-ignore
    return ApiService[APIConfig.CHECK_LOGIN.METHOD](APIConfig.CHECK_LOGIN.URL, {},
        {Authorization: "Bearer " + token}
    );
}

const LogoutAPICall = () => {
    // @ts-ignore
    return ApiService[APIConfig.LOGOUT.METHOD](APIConfig.LOGOUT.URL);
}

const switchProfile = (clientId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SWITCH_PROFILE.METHOD](APIConfig.SWITCH_PROFILE.URL(clientId), payload);
}

const exitProfile = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EXIT_PROFILE.METHOD](APIConfig.EXIT_PROFILE.URL, payload);
}

const AccountService = {
    RequestOTPAPICall,
    VerifyOTPAPICall,
    CheckLoginAPICall,
    LogoutAPICall,
    switchProfile,
    exitProfile
}

export default AccountService;
